<template>
  <div class="home flex flex-column">
    <div class="home-tabs" v-if="isShowHeader">
      <div class="width-full flex flex-row" style="height: 40px;">
        <div class="flex-1 gradient-bg"></div>
        <div class="home-tab text-align-center">
          <ul>
            <li v-if="isShow" :class="{active: activeName === 'data-panel'}" @click="activeName = 'data-panel'">企业数据看板
            </li>
            <li :class="{active: activeName === 'employee-panel'}" @click="activeName = 'employee-panel'">员工工作面板</li>
          </ul>
        </div>
        <div class="flex-1 gradient-bg">
          数据每1小时刷新一次
        </div>
      </div>
    </div>
    <div class="home-wrapper flex-1 relative">
      <component :is="activeName" :initial="qydataInitial" :is-login="isQyDataLogin" :start-time="startTime"></component>
      <div class="absolute" v-if="!qydataInitial">
        <iframe :src="qydataUrl + '/integration/zjyLogin?uniCode=' + gldUserId" frameborder="0" width="0" height="0" style="opacity: 0;width: 0px;height: 0px;"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dataPanel from './component/data-panel'
import employeePanel from './component/employee-panel'
import {on, off} from '@/assets/utils'
import {qydataUrl} from '@/assets/js/config'
import Bus from '@/assets/utils/bus'
import { getCookie } from '@/assets/utils/CommonUtil'

export default {
  name: 'index',
  components: {
    dataPanel,
    employeePanel
  },
  data () {
    return {
      qydataUrl,
      gldUserId: getCookie('gldUserId'),
      qydataInitial: false,
      isQyDataLogin: false,
      activeName: 'data-panel',
      notice: {
        defaultActiveKey: '1'
      },
      isShow: true,
      startTime: 0,
      isShowHeader: true
    }
  },
  computed: {
    ...mapState({
      menuList: state => state.menus.menuList.filter(item => (item.path === '/workbench'))
    })
  },
  watch: {
    qydataInitial (value) {
      if (value) {
        // 埋点：统计登录耗时
        let duration = ((Date.now() - this.startTime) / 1000).toFixed(2)
        this.sentLog(100118010, {duration})
      }
    },
    activeName (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.startTime = Date.now()
      }
    }
  },
  created () {
    this.startTime = Date.now()
    on(window, 'message', this.handMessage)
    Bus.$on('qyDataLogin', (frameLoginSuccess) => {
      this.qydataInitial = true
      this.isQyDataLogin = frameLoginSuccess
    })

    // this.activeName = 'employee-panel'
    setTimeout(() => {
      let menuList = this.menuList || []
      // let menuList = JSON.parse(sessionStorage.getItem('menuList'))
      console.log('企业数据看板', menuList, this.$store.state.menus.menuList)

      menuList.forEach(element => {
        // if (element.menuName === '工作台') {
        if (element.childrenMenu.length > 0) {
          console.log(element)

          this.isShow = true
          this.activeName = 'data-panel'
        } else {
          this.isShow = false
          this.activeName = 'employee-panel'
        }
        // }
      })
    }, 500)
    const activePanelName = this.$route.query.panelName
    if (activePanelName) {
      this.isShowHeader = false
      if (activePanelName === 'data') {
        this.activeName = 'data-panel'
      } else if (activePanelName === 'employee') {
        this.activeName = 'employee-panel'
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
  },
  beforeDestroy () {
    off(window, 'message', this.handMessage)
    // sessionStorage.removeItem('menuList')
  }
}
</script>

<style lang="less">
  .home {
    width: 100%;
    height: 100%;
    color: #ffffff;
    user-select: none;

    .home-tabs {
      width: 100%;
      height: 40px;

      .gradient-bg {
        height: 40px;
        background: url("~@/assets/images/home_title_bg.png") repeat-x;
        background-size: contain;
        line-height: 34px;
        text-align: right;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.55);
        padding-right: 24px;
        font-size: 12px;
      }

      .home-tab {
        width: 390px;
        height: 40px;
        padding: 8px 0;
        background: url("~@/assets/images/home_title.png") no-repeat center center;
        background-size: cover;
        box-sizing: border-box;

        ul {
          li {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 22px;
            cursor: pointer;
            transition: all .15s;

            &.active {
              font-size: 16px;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 24px;
            }

            & + li {
              margin-left: 24px;
            }
          }
        }
      }
    }

    .home-wrapper {
      padding: 12PX 16PX 16PX 16PX;
    }
  }
</style>
